import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle, ArrowLeft, Loader2 } from 'lucide-react';

export const StepShell = ({
  step, total, direction, title, hint, error, onBack, onSubmit, onSkip, wide = false, eyebrow = 'Create account', progressOnly = false,
  canContinue = true, loading = false, continueLabel = 'Continue', loadingLabel = 'Creating your account…', footer, children,
}) => (
  <div className="min-h-[calc(100dvh-72px)] bg-[#050816] flex flex-col" data-testid="signup-wizard">
    <div className="h-1 w-full bg-white/10" data-testid="signup-progress" role="progressbar" aria-label="Booking progress" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round((step / total) * 100)}>
      <div className="h-full bg-[#C6A14A] transition-[width] duration-500 ease-out" style={{ width: `${(step / total) * 100}%` }} />
    </div>
    <div className={`flex items-center justify-between px-4 sm:px-8 h-16 ${wide ? 'w-full max-w-md md:max-w-xl mx-auto md:px-6' : ''}`}>
      {onBack ? (
        <button type="button" onClick={onBack} className="h-11 w-11 -ml-3 inline-flex items-center justify-center text-[#E8E4DE]/70 hover:text-[#C6A14A] transition-colors" aria-label="Back" data-testid="signup-back-btn">
          <ArrowLeft className="h-5 w-5" />
        </button>
      ) : (
        <span className="text-xs tracking-[0.2em] uppercase text-[#C6A14A]">{eyebrow}</span>
      )}
      {!progressOnly && <span className="text-xs tracking-[0.2em] uppercase text-[#E8E4DE]/50" data-testid="signup-step-label">Step {step} of {total}</span>}
    </div>

    <form noValidate onSubmit={(e) => { e.preventDefault(); if (canContinue && !loading) onSubmit(); }}
      className={`flex-1 w-full ${wide ? 'max-w-md md:max-w-xl' : 'max-w-md'} mx-auto px-6 pt-8 sm:pt-16 pb-10`}>
      <div key={step} className={`animate-in fade-in duration-300 ${direction < 0 ? 'slide-in-from-left-6' : 'slide-in-from-right-6'}`}>
        <h1 className="font-serif text-3xl sm:text-4xl text-white leading-tight" data-testid="signup-question">{title}</h1>
        {hint && <p className="text-[#E8E4DE]/60 text-sm mt-3">{hint}</p>}
        <div className="mt-8 space-y-3">{children}</div>
        {error && (
          <div className="flex items-center gap-2 mt-4 p-3 text-sm text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg" data-testid="signup-error">
            <AlertCircle className="h-4 w-4 shrink-0" /><span>{error}</span>
          </div>
        )}
        <Button type="submit" disabled={!canContinue || loading}
          className="w-full mt-6 h-12 bg-[#C6A14A] text-[#050816] hover:bg-[#D4AF5A] font-semibold tracking-wide disabled:opacity-40"
          data-testid="signup-continue-btn">
          {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{loadingLabel}</> : continueLabel}
        </Button>
        {onSkip && (
          <button type="button" onClick={onSkip} className="w-full mt-3 min-h-[44px] text-sm text-[#E8E4DE]/50 hover:text-[#E8E4DE] transition-colors" data-testid="signup-skip-btn">
            Skip
          </button>
        )}
        {footer && <div className="mt-8 text-sm text-center text-[#E8E4DE]/60">{footer}</div>}
      </div>
    </form>
  </div>
);
